function SvgNavigation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path d='M13.306.88l8.686 21.17c.48 1.172-.72 2.345-1.878 1.822l-7.542-3.333a1.462 1.462 0 00-1.144 0l-7.542 3.333c-1.158.509-2.359-.65-1.879-1.822L10.693.88c.466-1.173 2.133-1.173 2.613 0z' />
    </svg>
  )
}

export default SvgNavigation
